module.exports = __webpack_public_path__ + "static/media/cmdr.8163166d.png";